// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3sP55","row":"ProcedureTreatmentSummary_row__1pBl4"};